import React, { useState, useEffect } from 'react'
import HorziBarChartsMain from '../../../BuisnessDashboard/common/HorizontalStackBarChart'
import { getPartnersByAggregatorIdbyName } from '../../ActionCreator'
import moment from 'moment'
import Loader from '../../../../../presentationals/Loader/Loader.component'
export default function Partner({ handleCustomTab, Data, dateFilterPopup, commonFilter, setDateFilterPopup }) {
    const [loader, setLoader] = useState(false)
    const [tableData, settableData] = useState([])

    useEffect(() => {
            if (
                commonFilter?.fromDate !== dateFilterPopup.from ||
                commonFilter?.toDate !== dateFilterPopup.to
            ) {
                setDateFilterPopup((prev) => ({
                    ...prev,
                    from: commonFilter.fromDate,
                    to: commonFilter.toDate
                }));
            }
            const obj = { start: moment(commonFilter.fromDate).format("DD-MM-YYYY"), end: moment(commonFilter.toDate).format("DD-MM-YYYY") }
            ApiData(obj)
        
        }, [commonFilter])

    const ApiData = (obj) => {
        setLoader(true)
        getPartnersByAggregatorIdbyName(obj?.start ?? "", obj?.end ?? "", Data?.id ?? "", callback => {
        // getPartnersByAggregatorIdbyName("01-01-2026", "29-01-2026", "131515588e04477c", callback => {
            setLoader(false)
            settableData(callback?.data ?? [])
        })
    }
    return (
        <>
            {loader ? <Loader /> : ""}
            <div className='OverView-Main-Section min-size-marketing-1800'>
                <div className="row">
                    <div className="col-sm-7 col-xs-12">
                        <div className="customDash-table" style={{ marginTop: '30px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <h5>Partner's List</h5>
                                <button style={{ background: '#035865', color: '#fff', padding: '6px 10px', borderRadius: '4px', marginRight: '10px' }} onClick={() => handleCustomTab("AddPartner", "")}>Add New Partner</button>
                            </div>
                            <div className='main-customized-table'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th>Partner Name</th>
                                            <th>Active Campaigns</th>
                                            <th>Leads</th>
                                            <th>Disbursement Amount</th>
                                            <th>Conversion %</th>
                                            {/* <th>Effective Cost</th> */}
                                            <th>Status</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            tableData?.length > 0 ? tableData?.map((val, id) => {
                                                return (
                                                    <tr key={id}>

                                                        <td>{val?.partnerName ?? ""}</td>
                                                        <td>{val?.activeCampaign ?? ""}</td>
                                                        <td>{val?.totalLeads ?? ""}</td>
                                                        <td>{val?.disbursementAmount ?? ""}</td>
                                                        <td>{val?.conversionRate ==  "NaN" ? 0 : val?.conversionRate ?? ""}</td>
                                                        <td>
                                                            <div style={{ borderRadius: '4px', padding: '8px', background: val?.status ? "#35A04F2B" : "#c02d2d2b", color: val?.status ? "#327E45" : "#ad3030" }}>
                                                                {val?.status ? "Active" : "Inactive" ?? ""}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                                : ""}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-5 col-xs-12" style={{ marginTop: '30px' }}>
                        <div>
                            <HorziBarChartsMain
                                heading={"Partner Performance"}
                                xAxisDataKey={"partnerName"}
                                barData={tableData} dataKeyName1={"totalLeads"} dataKeyName2={"totalDisbursedLeads"}
                                barcolor1={"#ebb569ff"} barcolor2={"#0d6e63ff"}
                                LegendLeft={"Leads"} LegendRight={"Disbursement"}
                                customHeight={"345px"}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
